import _extends from "@babel/runtime/helpers/extends";
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { cls } from '@arco-design/mobile-utils';
import { ContextLayout } from '../context-provider';
import { useSystem } from '../_helpers';
import IconClose from '../icon/IconClose';
export var Tag = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      style = props.style,
      _props$type = props.type,
      type = _props$type === void 0 ? 'primary' : _props$type,
      icon = props.icon,
      children = props.children,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      color = props.color,
      bgColor = props.bgColor,
      borderColor = props.borderColor,
      _props$borderStyle = props.borderStyle,
      borderStyle = _props$borderStyle === void 0 ? 'solid' : _props$borderStyle,
      _props$halfBorder = props.halfBorder,
      halfBorder = _props$halfBorder === void 0 ? true : _props$halfBorder,
      closeable = props.closeable,
      closeIcon = props.closeIcon,
      closeColor = props.closeColor,
      filleted = props.filleted,
      onClose = props.onClose,
      onClick = props.onClick;
  var domRef = useRef(null);
  var system = useSystem();
  useImperativeHandle(ref, function () {
    return {
      dom: domRef.current
    };
  });

  function getTagStyle() {
    return _extends({
      color: color,
      background: bgColor,
      borderColor: borderColor,
      borderStyle: borderStyle
    }, style || {});
  }

  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var prefixCls = _ref.prefixCls;
    var prefix = prefixCls + "-tag";
    return /*#__PURE__*/React.createElement("div", {
      className: cls(prefix, 'all-border-box', className, prefix + "-" + type, {
        'half-border': halfBorder
      }, system, "size-" + size, {
        filleted: filleted
      }),
      style: getTagStyle(),
      ref: domRef,
      onClick: onClick
    }, icon, /*#__PURE__*/React.createElement("span", {
      className: "tag-text"
    }, children), closeable ? /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(e) {
        e.stopPropagation();
        onClose && onClose(e);
      },
      className: "tag-close-wrap"
    }, closeIcon || /*#__PURE__*/React.createElement(IconClose, {
      className: "tag-close-icon",
      color: closeColor
    })) : null);
  });
});